export default __webpack_public_path__ + "static/media/Photo 5 - MR - Ensoleillement.f1781e59.png";